import { Divider } from '@patternfly/react-core'
import * as React from 'react'
import { useCallback } from 'react'

import type {
  IProgram,
  IProgramInteraction,
  IProgramInteractionId} from '@app/domain/program/program.interface';
import {
  IInteractionStatusId,
  ProgramInteractionTypeId,
  selectInteractionInstrumentsModalTittle,
} from '@app/domain/program/program.interface'

import { FollowUpInteraction } from './follow-up-interaction'
import { InteractionSection } from './interaction-section'

interface Props {
  program: IProgram
  onDeleteInteraction: (programIteractionId: IProgramInteractionId) => void
  onEditInteraction: (
    modalTittle: string,
    programInteractionTypeId: ProgramInteractionTypeId,
    programInteraction?: IProgramInteraction,
  ) => void
  onEditInteractionProperties: (
    interactionId: string,
    label?: string,
    daysAfterInitialInteraction?: number,
  ) => void
}

export const FollowUpInteractionSection = ({
  onDeleteInteraction,
  onEditInteraction,
  onEditInteractionProperties,
  program,
}: Props) => {
  const handleAddInteraction = useCallback(() => {
    return (event) => {
      event.preventDefault()
      onEditInteraction(
        selectInteractionInstrumentsModalTittle,
        ProgramInteractionTypeId.FollowUpInteraction,
      )
    }
  }, [onEditInteraction])

  const renderInteractions = (programInteractions: IProgramInteraction[]) => {
    if (!programInteractions || programInteractions.length === 0) {
      return null
    }

    const activeInteractions = programInteractions.filter(
      (interaction) => interaction.status !== IInteractionStatusId.Removed,
    )

    if (activeInteractions.length === 0) {
      return null
    }

    return activeInteractions.map((programInteraction) => (
      <FollowUpInteraction
        key={programInteraction.id}
        onDeleteInteraction={onDeleteInteraction}
        onEditInteraction={onEditInteraction}
        onEditInteractionProperties={onEditInteractionProperties}
        programInteraction={programInteraction}
      />
    ))
  }

  return (
    <InteractionSection
      toolTip="Scheduled interactions to collect follow-up information on a patient in a program."
      subtitle="Follow-up Interactions"
      addInteraction={handleAddInteraction()}
    >
      <Divider />
      {renderInteractions(
        program?.interactions[ProgramInteractionTypeId.FollowUpInteraction],
      )}
    </InteractionSection>
  )
}
